import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useLead } from '../../../hooks/Features/useLeads'
import { itemsPerPage } from '../../../shared/data'
import CustomPagination from '../../CustomPagination'
import Layout from '../../Layout'
import Loader from '../../Loader'
import CustomTable from '../../Table/CustomTable'
import CustomTableHeading from '../../Table/CustomTableHeading'
import CustomTableRow from '../../Table/CustomTableRow'
import styles from '../reports.module.css'
import { NoDataFound } from '../../NoDataFound'
import { SortIcon, FilterIcon } from '../../CustomComponents/CustomFilterIcon'

export default function LeadAgingReport() {
  const { loading, getLeadAgingReport, lead } = useLead()
  const [page, setPage] = useState(1)
  const startDate = new Date()
  startDate.setDate(1)
  startDate.setHours(0, 0, 0)
  const [from, setFrom] = useState(startDate.toISOString())
  const [to, setTo] = useState(new Date().toISOString())
  const [filterParams, setFilterParams] = useState({})

  useEffect(() => {
    setPage(1)
    getLeadAgingReport({ from, to, ...filterParams })
  }, [from, to, filterParams])

  const noOfPages = Math.ceil(lead && lead.length / itemsPerPage)
  const handleChange = (event, value) => {
    setPage(value)
  }

  const heading = [
    { label: 'Region', key: 'region' },
    { label: 'Zone', key: 'zone' },
    { label: 'State', key: 'state' },
    { label: 'District', key: 'district' },
    { label: 'City', key: 'city' },
    { label: 'Aging<=10', key: 'aging<=10' },
    { label: 'Aging<=11-20', key: 'aging<=11-20' },
    { label: 'Aging>20', key: 'aging>20' },
  ]

  let tempLead = []
  lead &&
    lead.forEach((item) =>
      tempLead.push({
        region: item.region && item.region.name,
        zone: item.zone && item.zone.name,
        state: item.state && item.state.name,
        district: item.district && item.district.name,
        city: item.city && item.city.name,
        'aging<=10': item.aging10,
        'aging<=11-20': item.aging20,
        'aging>20': item.aging30,
      })
    )

  const initialPara = { aging10: null, aging20: null, aging30: null }

  const headingOnClick = {
    'AGING<=10': () => {
      setFilterParams({ ...filterParams, ...initialPara, aging10: filterParams.aging10 === 1 ? -1 : 1 })
    },
    'AGING<=11-20': () => {
      setFilterParams({ ...filterParams, ...initialPara, aging20: filterParams.aging20 === 1 ? -1 : 1 })
    },
    'AGING>20': () => {
      setFilterParams({ ...filterParams, ...initialPara, aging30: filterParams.aging30 === 1 ? -1 : 1 })
    },
  }

  return (
    <Layout
      heading="Lead Aging Report"
      none
      selectedFrom={from}
      setSelectedFrom={setFrom}
      selectedTo={to}
      setSelectedTo={setTo}
      headers={heading}
      data={tempLead ? tempLead : []}
      tempHeaderData={[]}
      filename='lead_aging_report'
    >
      <CustomTable padding className={styles.table}>
        <CustomTableHeading
          filterIcons={{
            'AGING<=10': <SortIcon onClick={headingOnClick['AGING<=10']} value={filterParams.aging10} />,
            'AGING<=11-20': <SortIcon onClick={headingOnClick['AGING<=11-20']} value={filterParams.aging20} />,
            'AGING>20': <SortIcon onClick={headingOnClick['AGING>20']} value={filterParams.aging30} />,
          }}
          heading={['REGION', 'ZONE', 'STATE', 'DISTRICT', 'CITY', 'AGING<=10', 'AGING<=11-20', 'AGING>20']}
        />
        <TableBody className={styles.tr}>
          {!loading &&
            lead.length > 0 &&
            lead.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((item, index) => {
              return (
                <CustomTableRow>
                  <TableCell> {item.region ? item.region.name : '-----'} </TableCell>
                  <TableCell> {item.zone ? item.zone.name : '-----'} </TableCell>
                  <TableCell> {item.state ? item.state.name : '-----'} </TableCell>
                  <TableCell> {item.district ? item.district.name : '-----'} </TableCell>
                  <TableCell> {item.city ? item.city.name : '-----'} </TableCell>
                  <TableCell> {item.aging10} </TableCell>
                  <TableCell> {item.aging20} </TableCell>
                  <TableCell> {item.aging30} </TableCell>
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      {loading && <Loader />}
      {!loading && lead.length > 0 && (
        <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />
      )}

      {!loading && lead.length === 0 && <NoDataFound />}
    </Layout>
  )
}
